// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthCell_root__1Kc8g"};